import { render, staticRenderFns } from "./DashboardResponsibles.vue?vue&type=template&id=8c1f8cbc"
import script from "./DashboardResponsibles.vue?vue&type=script&lang=js"
export * from "./DashboardResponsibles.vue?vue&type=script&lang=js"
import style0 from "./DashboardResponsibles.vue?vue&type=style&index=0&id=8c1f8cbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports